import type { GatsbyBrowser } from 'gatsby';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'normalize.css';

import { ZendeskChatButton } from './src/components/ZendeskChatButton';
import './src/styles/base.scss';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  const container = document.createElement('div');
  container.id = 'zendesk-chat-button-root';
  document.body.appendChild(container);

  createRoot(container).render(React.createElement(ZendeskChatButton));
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  if (typeof window.oaiq !== 'function') return;

  window.oaiq('measure', 'page_viewed', { type: 'contents' });
};
